"use client";

import { ReactNode } from "react";

export function ModalProvider({ children }: { children?: ReactNode }) {
  // Simple placeholder modal provider
  return <>{children}</>;
}
